<template>
  <div
    v-if="!loading"
    class="signature-container"
    style="
      background-color: var(--theme-bg-color);
      color: var(--theme-text-color-darken);
    "
  >
    <van-nav-bar
      :title="title"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
    />

    <div
      v-if="signatureStep == 1"
      class="flex items-center"
      style="
        width: 100%;
        height: calc(100dvh - 1rem);
        flex-direction: column;
        font-size: 0.35rem;
      "
    >
      <img
        :src="activeImg"
        alt=""
        style="width: 95%; margin-top: 0.3rem; border-radius: 0.2rem"
      />
      <span style="padding: 0.3rem">
        Assine um contrato com a plataforma agora mesmo!<br /><br />
        e torne-se um influenciador ou blogueiro oficial.<br /><br />
        Comece a ganhar dinheiro agora!
      </span>
      <div
        class="primary_button"
        style="
          cursor: pointer;
          background-color: var(--theme-disabled-bg-color);
          color: #fff;
          margin-top: 1rem;
        "
        @click="signatureStep = 2"
      >
        <div class="text">
          <p><span>Pré-visualização do contrato</span></p>
        </div>
      </div>
      <div
        class="primary_button"
        style="cursor: pointer; margin-top: 0.6rem"
        @click="signatureStep = 3"
      >
        <div class="text">
          <p><span>Inscreva-se agora</span></p>
        </div>
      </div>
    </div>
    <div
      v-if="signatureStep == 2"
      style="width: 100%; height: calc(100dvh - 1rem); overflow: scroll"
    >
      <img :src="imgUrl" alt="" style="width: 100%" />
    </div>
    <div
      v-if="signatureStep == 3"
      style="
        width: calc(100% - 0.7rem);
        height: calc(100dvh - 1.7rem);
        overflow: scroll;
        font-size: 0.34rem;
        padding: 0.35rem 0.3rem;
      "
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0">
        <van-icon name="manager" color="var(--theme-primary-color)" />
        <span style="font-size: 0.36rem; margin-left: 0.2rem"
          >Informações pessoais</span
        >
        <div
          style="
            width: 100%;
            height: 0.02rem;
            background-color: #fff;
            margin-top: 0.1rem;
          "
        ></div>
        <el-form-item prop="name" style="margin-top: 0.2rem;">
          <span style="font-size: 0.3rem;">Nome completo</span>
          <el-input
            v-model="ruleForm.name"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="cpf">
          <span style="font-size: 0.3rem">CPF</span>
          <el-input
            v-model="ruleForm.cpf"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="addr">
          <span style="font-size: 0.3rem">Endereço residencial</span>
          <el-input
            v-model="ruleForm.addr"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <div style="margin-top: 0.8rem; margin-bottom: 0.2rem">
          <van-icon name="records" color="var(--theme-primary-color)" />
          <span style="font-size: 0.36rem; margin-left: 0.2rem"
            >Metas de resultados</span
          >
          <div
            style="
              width: 100%;
              height: 0.02rem;
              background-color: #fff;
              margin-top: 0.1rem;
            "
          ></div>
        </div>
        <el-form-item prop="target_1_1">
          <div style="font-size: 0.35rem">Alvo 1</div>
          <div style="font-size: 0.3rem">
            Meta de depositantes válidos (nº)
          </div>
          <el-input
            v-model="ruleForm.target_1_1"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="target_1_2">
          <div style="font-size: 0.3rem">Salário recebido (R$)</div>
          <el-input
            v-model="ruleForm.target_1_2"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="target_2_1">
          <div style="font-size: 0.35rem">Alvo 2</div>
          <div style="font-size: 0.3rem">Meta de valor de depósitos (R$)</div>
          <el-input
            v-model="ruleForm.target_2_1"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="target_2_2">
          <div style="font-size: 0.3rem">Salário recebido (R$)</div>
          <el-input
            v-model="ruleForm.target_2_2"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="target_3_1">
          <div style="font-size: 0.35rem">Alvo 3</div>
          <div style="font-size: 0.3rem">Meta de dias de parceria (dias)</div>
          <el-input
            v-model="ruleForm.target_3_1"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
        <el-form-item prop="target_3_2">
          <div style="font-size: 0.3rem">Salário recebido (R$)</div>
          <el-input
            v-model="ruleForm.target_3_2"
            placeholder="Por favor, insira"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="width: 100%; margin-top: 0.5rem"
        class="flex justify-center items-center"
      >
        <div
          style="
            cursor: pointer;
            background-color: var(--theme-primary-color);
            width: 5rem;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            color: var(--theme-primary-font-color);
            border-radius: 0.1rem;
          "
          @click="goSignature"
        >
          <p><span>Próximo passo</span></p>
        </div>
      </div>
    </div>
    <div
      v-if="signatureStep == 4"
      style="
        width: 100%;
        height: calc(100dvh - 1rem);
        font-size: 0.35rem;
        position: relative;
      "
    >
      <div
        style="
          width: 6.8rem;
          height: 6.8rem;
          background: #fff;
          border: 0.02rem solid #797979;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          margin: 0.5rem auto;
        "
      >
        <VueSignaturePad
          ref="signaturePad"
          :options="{
            penColor: '#000',
            minWidth: 10
          }"
        />
      </div>
      <div
        style="
          padding: 0.2rem 0.5rem;
          position: absolute;
          left: 0;
          right: 0;
          top: 7.5rem;
          margin: 0 auto;
        "
      >
        <span>Por favor, assine seu nome à mão na caixa de texto acima.</span>
      </div>
      <div
        style="
          position: absolute;
          width: 5.5rem;
          left: 0;
          right: 0;
          bottom: 1rem;
          margin: 0 auto;
        "
      >
        <div
          class="primary_button"
          style="
            cursor: pointer;
            background-color: var(--theme-disabled-bg-color);
            color: #fff;
          "
          @click="clearSignature"
        >
          <div class="text">
            <p><span>Limpar</span></p>
          </div>
        </div>
        <div
          class="primary_button"
          style="cursor: pointer; margin-top: 0.5rem"
          @click="saveSignature"
        >
          <div class="text">
            <p><span>Salvar assinatura</span></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 已签约状态 -->
    <div
      v-if="signatureStep == 5"
      class="flex items-center"
      style="
        width: 100%;
        height: calc(100dvh - 1rem);
        flex-direction: column;
        font-size: 0.34rem;
      "
    >
      <img :src="activeImg" alt="" style="width: 90%; margin-top: 0.3rem" />
      <span style="padding: 0.3rem">
        Parabéns, meu amigo! <br /><br />
        Você se tornou um blogueiro contratado na plataforma. <br /><br />
        Ao promover a plataforma conforme os termos do contrato, você poderá
        receber as recompensas correspondentes. <br /><br />
        Comece agora e aproveite as oportunidades!
      </span>
      <div
        class="primary_button"
        style="cursor: pointer"
        @click="mergeimg(), (signatureStep = 7)"
      >
        <div class="text">
          <p><span>Pré-visualização do contrato</span></p>
        </div>
      </div>
    </div>
    <!-- 待签约状态 -->
    <div
      v-if="signatureStep == 6"
      class="flex items-center"
      style="
        width: 100%;
        height: calc(100dvh - 1rem);
        flex-direction: column;
        font-size: 0.35rem;
      "
    >
      <img :src="activeImg" alt="" style="width: 90%; margin-top: 0.3rem" />
      <span style="padding: 0.3rem">
        Por favor, aguarde um momento.<br /><br />
        Nossa equipe está verificando no sistema o contrato que você enviou.<br />
        Após a confirmação, você se tornará um blogueiro/influenciador
        contratado da plataforma.<br /><br />
        Caso haja algum erro no preenchimento dos termos do contrato, entre em
        contato com a equipe, atualize a página e preencha novamente.
      </span>
      <div
        class="primary_button"
        style="cursor: pointer"
        @click="mergeimg(), (signatureStep = 7)"
      >
        <div class="text">
          <p><span>Pré-visualização do contrato</span></p>
        </div>
      </div>
    </div>
    <div
      v-if="signatureStep == 7"
      style="width: 100%; height: calc(100dvh - 1rem); overflow: scroll"
    >
      <!-- <img :src="sale_sign" alt="" /> -->
      <img :src="mergedImage" alt="" style="width: 100%" />
    </div>
  </div>
  <div
    v-else
    v-loading="loading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    style="width: 100%; height: 100dvh"
  ></div>
</template>

<script>
import { signatureInit, doSignature } from '@/apis/modules/home.js';
export default {
  data() {
    return {
      loading: false,
      imgUrl: require('../assets/icons/images/ht_model.png'), //合同模版
      sale_sign: null, // 业务员签名
      user_sign: null, // 博主签名
      mergedImage: null, //签署完成合同图片
      activeImg: require('../assets/icons/images/active_model.jpg'),
      title: 'Assinatura de contrato',
      status: 0,
      signatureStep: 1, //签约步骤
      sign_time: '',
      ruleForm: {
        sign_img: null,
        name: '',
        cpf: '',
        addr: '',
        target_1_1: '',
        target_2_1: '',
        target_3_1: '',
        target_1_2: '',
        target_2_2: '',
        target_3_2: ''
      },
      rules: {
        name: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        cpf: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        addr: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_1_1: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_2_1: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_3_1: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_1_2: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_2_2: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ],
        target_3_2: [
          { required: true, message: 'Por favor, insira', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    signatureStep(val) {
      if (val == 1 || val == 3 || val == 5) {
        this.title = 'Assinatura de contrato';
      } else if (val == 4) {
        this.title = 'Confirmação de assinatura';
      } else {
        this.title = 'Pré-visualização do contrato';
      }
    }
  },
  methods: {
    goBack() {
      if (
        this.signatureStep === 1 ||
        this.signatureStep === 5 ||
        this.signatureStep === 6
      ) {
        this.$router.push({ name: 'home' });
        return;
      }
      if (this.signatureStep == 7) {
        if (this.status == 2) {
          this.signatureStep = 5;
        } else {
          this.signatureStep = 6;
        }
        return;
      }
      if (this.signatureStep === 3) {
        this.signatureStep = 1;
      } else {
        this.signatureStep--;
      }
    },
    goSignature() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.signatureStep = 4;
        } else {
          this.$message({
            message: 'Por favor preencha as informações',
            type: 'warning'
          });
          return false;
        }
      });
    },
    //合并图片
    async mergeimg() {
      this.loading = true;
      // 创建一个 canvas 元素
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // 创建两个图像对象
      const img1 = new Image();
      const img2 = new Image();
      // 设置图像的 src 属性为 Base64 编码的字符串
      img1.src = this.imgUrl;
      img2.src = this.user_sign;
      // 设置 canvas 的宽度和高度
      // 这里假设我们将图像水平排列，因此宽度是两幅图宽度之和，高度取最大值
      canvas.width = img1.width;
      canvas.height = img1.height;
      if (canvas.width == 0) {
        setTimeout(() => {
          this.mergeimg();
        }, 1000);
        return;
      }
      // 绘制第一张图像
      await ctx.drawImage(img1, 0, 0);
      // 绘制第二张图像，放置在第一张图像的右边
      await ctx.drawImage(img2, 800, Number(img1.height) - 1040, 200, 200);
      ctx.font = '60px Arial';
      ctx.fillStyle = 'black';
      if (this.sign_time) {
        //绘制日期
        const date = new Date(this.sign_time * 1000);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份从0开始计数，因此要加1
        const day = date.getDate();
        ctx.fillText(year, 680, Number(img1.height) - 1700);
        ctx.fillText(month, 950, Number(img1.height) - 1700);
        ctx.fillText(day, 1160, Number(img1.height) - 1700);
      }
      ////
      ctx.fillText(this.ruleForm.name, 1000, 1930);
      ctx.fillText(this.ruleForm.cpf, 1750, 1930);
      ctx.fillText(this.ruleForm.addr, 550, 2050);
      ctx.fillText(
        this.ruleForm.target_1_1,
        1500,
        Number(img1.height) / 2 - 345
      );
      ctx.fillText(
        this.ruleForm.target_1_2,
        2400,
        Number(img1.height) / 2 - 345
      );
      ctx.fillText(
        this.ruleForm.target_2_1,
        1480,
        Number(img1.height) / 2 - 170
      );
      ctx.fillText(
        this.ruleForm.target_2_2,
        2360,
        Number(img1.height) / 2 - 170
      );
      ctx.fillText(this.ruleForm.target_3_1, 1460, Number(img1.height) / 2 + 5);
      ctx.fillText(this.ruleForm.target_3_2, 2320, Number(img1.height) / 2 + 5);
      // 将合并后的图像导出为 Base64 编码的字符串
      if (this.sale_sign) {
        const img3 = new Image();
        img3.src = this.sale_sign;
        img3.onload = async () => {
          await ctx.drawImage(img3, 800, Number(img1.height) - 1580, 200, 200);
          this.mergedImage = canvas.toDataURL('image/png');
        };
      } else {
        this.mergedImage = canvas.toDataURL('image/png');
      }

      this.loading = false;
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.ruleForm.sign_img = data;
        this.$confirm(
          'Tem certeza de que deseja assinar o contrato?',
          'Confirmação do contrato',
          {
            confirmButtonText: 'confirmar',
            cancelButtonText: 'retornar'
          }
        )
          .then(() => {
            this.loading = true;
            doSignature(this.ruleForm).then(() => {
              this.signatureInit();
            });
          })
          .catch(() => {});
      } else {
        this.$message({
          message: 'Nenhuma assinatura detectada.',
          type: 'warning'
        });
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    signatureInit() {
      this.loading = true;
      signatureInit({}).then(({ code, data = {}, msg }) => {
        this.sign_time = data.sign_time;
        this.status = data.status;
        if (data.img !== '#') {
          this.activeImg = data.img;
        }
        if (data.status == 1) {
          this.signatureStep = 6;
        }
        if (data.status == 2) {
          this.signatureStep = 5;
          this.sale_sign = data.sale_sign;
        }
        if (data.status !== 0) {
          this.user_sign = data.user_sign;
          this.ruleForm = data.info;
        }
        this.loading = false;
      });
    }
  },
  mounted() {
    this.signatureInit();
  }
};
</script>
<style scoped>
:deep(.el-input__inner) {
  background-color: var(--theme-bg-color);
  color: #fff;
  border-radius: 0.14rem;
  height: 0.7rem;
  font-size: 0.28rem;
}
:deep(.el-input__inner:focus) {
  border-color: var(--theme-primary-color);
}
.signature-container {
  background-color: #f2f2f2;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
}
.primary_button {
  border: none;
  border-radius: 0.1rem;
  padding: 0 0.5rem;
  width: 4.5rem;
  height: 0.8rem;
  color: var(--theme-primary-font-color);
  background-color: var(--theme-primary-color);
  line-height: 0.8rem;
  text-align: center;
  margin-top: 0.2rem;
}
:deep(.van-nav-bar) {
  background-color: var(--theme-top-nav-bg);
}
:deep(.van-nav-bar__title) {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  line-height: 1.2;
  overflow: hidden;
  overflow: initial;
  text-align: center;
  text-overflow: ellipsis;
  white-space: initial;
  vertical-align: middle;
  word-break: break-word;
  color: #fff;
  font-size: 0.3rem;
}
:deep(.van-icon) {
  color: #fff;
  font-size: 0.4rem;
}
</style>
